module.exports = __webpack_public_path__ + "img/clock.98f08f4e.png";